import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import {NavLink, useLocation} from 'react-router-dom'
import {withRouter} from 'react-router'
import {connect} from 'react-redux';
import {setMenuVisible, pageChange} from '../actions/'

import LanguageSelect from './LanguageSelect'

import styles from './MainMenu.module.css'
import {loadResourcesAbout} from "../utils/homeUtils";
import http from "../utils/http-common";

class MainMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMenuVisible: true,
            language: "",
            menu: {
                about: "",
                productions: "",
                coProductions: "",
                developments: "",
                contact: ""
            }
        }
        this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
        this.getLanguage = this.getLanguage.bind(this);
    }

    componentDidMount() {
       this.getLanguage();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.language !== this.props.language) {
            this.getLanguage();
        }
    }

    getLanguage() {
        http.get("/api/v1/menu?language=" + localStorage.getItem("language"))
            .then(res=>{
                this.setState({menu: res.data});
            }).catch(error=>{console.log(error)});
    }

    handleMenuItemClick = (path, e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.pageChange({
            prevUrl: this.props.history.location.pathname,
            nextUrl: path
        });
    }

    handleMenuClose = () => {
        this.props.setMenuVisible(false);
    }

    getLanguageClass = () => {
        switch(this.props.language) {
            case "EN":
                return styles.en;
            default:
                return '';
        }
    }

    render() {
        return (
            <>
                <div className={`${styles.menu_container} ${styles.desktop} ${this.getLanguageClass()}`}>
                    <div className={styles.language_container}>
                        <div className={styles.language_overlay}></div>
                        <div>
                            <div className={styles.logo}>
                                <img src={process.env.PUBLIC_URL + "/images/icons/svg/icon_outland_logo.svg"}
                                     onClick={e => this.handleMenuItemClick("/latest", e)}/>
                            </div>
                            <div className={styles.language_bar}>
                                <LanguageSelect/>
                            </div>
                        </div>
                    </div>
                    <div className={styles.menu_item_container}>
                        <div className={styles.menu}>
                            <div className={styles.menu_item}><NavLink to="/about"
                                                                       onClick={e => this.handleMenuItemClick("/about", e)}
                                                                       activeClassName={styles.menu_item_active}>{this.state.menu.about}</NavLink>
                            </div>
                            <div className={styles.menu_item}><NavLink to="/production_list"
                                                                       onClick={e => this.handleMenuItemClick("/production_list", e)}
                                                                       activeClassName={styles.menu_item_active}>{this.state.menu.productions}</NavLink>
                            </div>
                            <div className={styles.menu_item}><NavLink to="/co_production"
                                                                       onClick={e => this.handleMenuItemClick("/co_production", e)}
                                                                       activeClassName={styles.menu_item_active}>{this.state.menu.coProductions}</NavLink>
                            </div>
                            <div className={styles.menu_item}><NavLink to="/department"
                                                                       onClick={e => this.handleMenuItemClick("/department", e)}
                                                                       activeClassName={styles.menu_item_active}>{this.state.menu.developments}</NavLink>
                            </div>
                            <div className={styles.menu_item}><NavLink to="/contact"
                                                                       onClick={e => this.handleMenuItemClick("/contact", e)}
                                                                       activeClassName={styles.menu_item_active}>{this.state.menu.contact}</NavLink>
                            </div>
                        </div>
                    </div>
                    <div className={styles.close_button} onClick={this.handleMenuClose}>
                        <div className={styles.left_line}>
                            <div className={styles.right_line}></div>
                        </div>
                    </div>
                </div>

                <div className={`${styles.menu_container} ${styles.mobile} ${this.getLanguageClass()}`}>
                    <div className={styles.language_overlay}></div>
                    <div className={styles.menu_content_wrapper}>
                        <div className={styles.logo}>
                            <img src={process.env.PUBLIC_URL + "/images/menu/ol_Logo_2019ver-w.png"}
                                 onClick={e => this.handleMenuItemClick("/latest", e)}/>
                        </div>
                        <div className={styles.menu_item_container}>
                            <div className={styles.menu}>
                                <div className={styles.menu_item}><NavLink to="/about"
                                                                           onClick={e => this.handleMenuItemClick("/about", e)}
                                                                           activeClassName={styles.menu_item_active}>{this.state.menu.about}</NavLink>
                                </div>
                                <div className={styles.menu_item}><NavLink to="/production_list"
                                                                           onClick={e => this.handleMenuItemClick("/production_list", e)}
                                                                           activeClassName={styles.menu_item_active}>{this.state.menu.productions}</NavLink>
                                </div>
                                <div className={styles.menu_item}><NavLink to="/co_production"
                                                                           onClick={e => this.handleMenuItemClick("/co_production", e)}
                                                                           activeClassName={styles.menu_item_active}>{this.state.menu.coProductions}</NavLink>
                                </div>
                                <div className={styles.menu_item}><NavLink to="/department"
                                                                           onClick={e => this.handleMenuItemClick("/department", e)}
                                                                           activeClassName={styles.menu_item_active}>{this.state.menu.developments}</NavLink>
                                </div>
                                <div className={styles.menu_item}><NavLink to="/contact"
                                                                           onClick={e => this.handleMenuItemClick("/contact", e)}
                                                                           activeClassName={styles.menu_item_active}>{this.state.menu.contact}</NavLink>
                                </div>
                            </div>
                        </div>
                        <div className={styles.language_bar}>
                            <LanguageSelect/>
                        </div>
                    </div>
                    <div className={styles.close_button} onClick={this.handleMenuClose}>
                        <div className={styles.left_line}>
                            <div className={styles.right_line}></div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

const mapStateToProps = state => {
    return {language: state.language};
};

MainMenu = withRouter(MainMenu);
export default connect(mapStateToProps, {setMenuVisible, pageChange})(MainMenu);